import React, { useEffect, useCallback, useState} from 'react';
import {parse, getCycleString} from 'effects/midi/tidal/parser.js';
import {connect} from 'react-redux';
import {FIGURE} from './constants.js';
import {FIGURES} from 'effects/midi/jaki/constants.js';
import Dropdown from 'react-dropdown';

const FigureScreen = ({setChosen, effect, chosen}) => { 
    let {figure} = chosen;
    const deleteFigure = useCallback(() => {
        effect.figures.deleteFigure(figure);
        setChosen(undefined);
    }, [figure, effect, setChosen]);

    const setFigure = useCallback((newFigure) => {
        newFigure = effect.figures.updateFigure(figure, newFigure);
        setChosen({
            type: FIGURE,
            figure: newFigure
        });
    }, [setChosen, figure]);

    const setFigureLength = useCallback((o) => {
        let len = o.value;
        let newFigure = FIGURES[len][0];
        setFigure(newFigure);
    }, [setChosen, figure]);

    let options = FIGURES[Math.round(figure.figureLength)];
    let cycleString = figure.toString();
    return (
        <div className="figure-screen">
          <div onClick={(e) => {
              e.stopPropagation();
              deleteFigure();
          }} className="delete-btn">x</div>
          <div
            onClick={(e) => e.stopPropagation()}
            className="figure-header">
            Figure 
            <Dropdown
              value={{label: figure.figureLength, value: figure.figureLength}}
              onChange={setFigureLength}
              options={Object.keys(FIGURES).map(x => ({label:x,value:x}))}
            />
          </div>
          <div className="figure-options">
            {options.map(
                x => <div
                       onClick={(e) => {
                           e.stopPropagation();
                           setFigure(x);
                       }}
                       className={eq(cycleString, x) ? "cycle-option selected" : "cycle-option"}>
                       {x}
                     </div>)}
          </div>
        </div>);
};

const eq = (a,b) => {
    let _a = a.split(" ").join("");
    let _b = b.split(" ").join("");

    let ret = _a === _b;
    return ret;
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FigureScreen);
